<template>
    <div class="dashboard-container">
        <nav class="add-navigation container-fluid">
            <div class="row">
                <div class="input-div col-md col-12 ">
                    <span class="filter_by">Start Time:</span>
                    <div class="selects-wrapper">
                        <date-time-picker
                                :initial_time="new Date(startTime)"
                                @getTime="getStartTime"
                                header_font_size="12"
                                header_font_weight="900"
                                header_font_color="#000"
                        ></date-time-picker>
                    </div>
                </div>
                <div class="input-div col-md col-12 my-3 my-md-0">
                    <span class="filter_by">End Time:</span>
                    <div class="selects-wrapper">
                        <date-time-picker
                                :initial_time="new Date(endTime)"
                                @getTime="getEndTime"
                                header_font_size="12"
                                header_font_weight="900"
                                header_font_color="#000"
                        ></date-time-picker>
                    </div>
                </div>

                <div class="selects-wraper d-flex col-md col-12">
                    <span class="filter_by">Bucketization:</span>
                    <primary-select type="text" v-model="bucketization" class="Bucketization" placeholder="Choose">
                        <option value="day">Daily</option>
                        <option value="hour">Hourly</option>
                        <option value="all">All</option>
                    </primary-select>
                </div>
            </div>
            <div class="left-wrapper row">
                <div class="col-md-6 col-12 ">
                    <div class="bg-white p-3 h-100">
                        <div class="search-div">
                            <span>Number:</span>
                            <div class="selects-wrapper">
                                <search-input v-model="number" class="search-input" type="text"/>
                            </div>
                        </div>
<!--                        <div class="frequentlyused-div">-->
<!--                            <span>Frequently used</span>-->
                            <!-- <div class="frequently-div">
                              <div>
                                <span>451-541-5590</span>
                                <svg
                                  data-v-22ac3b44
                                  width="30px"
                                  height="30px"
                                  viewBox="0 0 30 30"
                                  version="1.1"
                                  class="svg-grey"
                                >
                                  <path
                                    data-v-22ac3b44
                                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                                    id="path-1"
                                  />
                                </svg>
                              </div>
                              <div>
                                <span>451-541-5590</span>
                                <svg
                                  data-v-22ac3b44
                                  width="30px"
                                  height="30px"
                                  viewBox="0 0 30 30"
                                  version="1.1"
                                  class="svg-grey"
                                >
                                  <path
                                    data-v-22ac3b44
                                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                                    id="path-1"
                                  />
                                </svg>
                              </div>
                              <div>
                                <span>451-541-5590</span>
                                <svg
                                  data-v-22ac3b44
                                  width="30px"
                                  height="30px"
                                  viewBox="0 0 30 30"
                                  version="1.1"
                                  class="svg-grey"
                                >
                                  <path
                                    data-v-22ac3b44
                                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                                    id="path-1"
                                  />
                                </svg>
                              </div>
                            </div>-->
<!--                        </div>-->
<!--                        <div class="selectedus-div">-->
<!--                            <span>SELECTED</span>-->
                            <!-- <div class="selected-div">
                              <div>
                                <span>451-541-5590</span>
                                <svg
                                  data-v-22ac3b44
                                  width="30px"
                                  height="30px"
                                  viewBox="0 0 30 30"
                                  version="1.1"
                                  class="svg-grey"
                                >
                                  <path
                                    data-v-22ac3b44
                                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                                    id="path-1"
                                  />
                                </svg>
                              </div>
                              <div>
                                <span>451-541-5590</span>
                                <svg
                                  data-v-22ac3b44
                                  width="30px"
                                  height="30px"
                                  viewBox="0 0 30 30"
                                  version="1.1"
                                  class="svg-grey"
                                >
                                  <path
                                    data-v-22ac3b44
                                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                                    id="path-1"
                                  />
                                </svg>
                              </div>
                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="bg-white p-3 h-100">
                        <div class="search-div">
                            <primary-select
                                    type="text"
                                    class="full-size-field"
                                    name="Country:"
                                    is-cross="true"
                                    v-model="selectedCountry"
                                    placeholder="Select Country"
                            >
                                <option
                                        v-for="(i, index) in countries"
                                        :value="i.iso2"
                                        :key="index"
                                >
                                    {{ i.nice_name }}
                                </option>
                            </primary-select>
                            <!--                            <div class="selects-wrapper">-->
                            <!--                                <search-input v-model="selectedCountry" class="search-input" type="text"/>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <div>
            <div class="groopBy_checkbox">
                <div class="custom-control custom-checkbox checkbox-xl">
                    <input type="checkbox" class="custom-control-input" id="Group by Number" v-model="checkedNumber"/>
                    <label class="custom-control-label" for="Group by Number">Group By Number</label>
                </div>
                <div class="custom-control custom-checkbox checkbox-xl">
                    <input type="checkbox" class="custom-control-input" id="Group by Destination"
                           v-model="checkedDestination"/>
                    <label class="custom-control-label" for="Group by Destination">Group By Destination</label>
                </div>
                <!--                <div class="custom-control custom-checkbox checkbox-xl">-->
                <!--                    <input type="checkbox" class="custom-control-input" id="Group by Client"/>-->
                <!--                    <label class="custom-control-label" for="Group by Client">Group by Client</label>-->
                <!--                </div>-->
                <!--                <div class="custom-control custom-checkbox checkbox-xl">-->
                <!--                    <input type="checkbox" class="custom-control-input" id="Group by Vendor"/>-->
                <!--                    <label class="custom-control-label" for="Group by Vendor">Group by Vendor</label>-->
                <!--                </div>-->
            </div>
        </div>

        <div class="col-12 btns d-flex justify-content-end mb-4">
            <div class="reset-button mr-sm-2 mr-1">
                <button class="PrimaryButton ff-p fw-5 fs-15" @click="downloadCSV">
                    Export
                </button>
            </div>
            <div class="reset-button mr-sm-2 mr-1">
                <button class="PrimaryButton ff-p fw-5 fs-15" @click="search">
                    Submit
                </button>
            </div>
            <div class="reset-button">
                <button class="secondary-button" @click="reasetFilters">
                    Reset
                </button>
            </div>
        </div>
        <loader :loading="loading" v-if="loading"/>
        <not-found v-if="!is_found" />
        <div v-else class="table_div" style="width:100%;overflow-x:auto;">
            <table class="Invoice_table">
                <thead>
                <tr class="Invoice_table_header">
                    <th class="companyName" rowspan="2">
                        Date
                        <span @click="sorting('up', 'sms_time')" class="sorting"
                        >&#8593;</span
                        >
                        <span @click="sorting('down', 'sms_time')" class="sorting"
                        >&#8595;</span
                        >
                    </th>
                    <th v-if="checkedNumber" class="balance" rowspan="2">Number</th>
                    <th v-if="checkedDestination" class="balance" rowspan="2">Country</th>
                    <th style="min-width: 160px" class="postpay">Incoming SMS</th>
                    <th class="contact" colspan="4">Outgoing SMS</th>
                </tr>
                <tr class="Invoice_table_header">
                    <th>Count</th>
                    <th>Count</th>
                    <th>Sent</th>
                    <th>Error</th>
                    <th>Cost</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(report, k) in list" :key="k">
                    <th>{{ moment(report.sms_time*1000).format('YYYY-MM-DD HH:mm:ss') }}</th>
                    <th v-if="checkedNumber">{{ report.dnis }}</th>
                    <th v-if="checkedDestination">{{ report.country }}</th>
                    <th style="min-width: 160px">-</th>
                    <th>{{ report.sent }}</th>
                    <th>{{ report.delivered }}</th>
                    <th>-</th>
                    <th>{{ report.tx_cost }}</th>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {format} from "date-fns";
    import {mapGetters, mapActions} from "vuex";
    import moment from 'moment';

    export default {
        components: {
            ResellersLine: () =>
                import("@/components/Charts/Reporting/ResellersLine.js"),
            CompaniesLine: () =>
                import("@/components/Charts/Reporting/CompaniesLine.js"),
            BarChart: () => import("@/components/Charts/Dashboard/BarChart.js"),
            BarChartSecond: () => import("@/components/Charts/Dashboard/BarChart2.js"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
            CardComponent: () => import("@/components/CardComponent.vue"),
            Loader: () => import("@/components/Loader.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            DateTimePicker: () => import("@/components/DateTime"),
        },
        data: () => ({
            moment,
            is_found: false,
            bucketization: 'day',
            start_time: null,
            end_time: null,
            number: null,
            country: null,
            countries: [],
            searchPhone: '',
            selectedCountry: null,
            checkedNumber: false,
            checkedDestination: false,
            loading: true,
            list: []
        }),
        computed: {
            startTime() {
                const {day, month, year} = this.getCurrentDateAndTime();

                return new Date(`${month}/${day}/${year} 00:00:00`).getTime();
            },
            endTime() {
                const {day, month, year} = this.getCurrentDateAndTime();

                return new Date(`${month}/${day}/${year} 23:59:59`).getTime();
            },
        },
        watch: {
            checkedNumber(val) {
                this.search();
            },
            checkedDestination(val) {
                this.search();
            }
        },
        async created() {
            this.setDateAndTime();
            this.getList();
            this.getCountries();

        },
        methods: {
            async getList(order_dir = "desc", order_by = "sms_time") {
                this.loading = true;
                let group = '';
                if(this.number && this.selectedCountry) group = 'dnis,country';
                else if(this.checkedDestination && this.number) group = 'dnis,country';
                else if(this.selectedCountry && this.checkedDestination) group = 'dnis,country';
                else if(this.checkedNumber && this.checkedDestination) group = 'dnis,country';
                else if(this.number || this.checkedNumber) group = 'dnis';
                else if(this.selectedCountry || this.checkedDestination) group = 'country';
                else group = '';

                await this.$store.dispatch("GetNumbersCompanyReportList", {
                    start_time: new Date(this.start_time * 1000).getTime() / 1000,
                    end_time: new Date(this.end_time * 1000).getTime() / 1000,
                    step: this.bucketization,
                    number: this.number,
                    country: this.selectedCountry ? this.selectedCountry : '',
                    order_dir: order_dir,
                    order_by: order_by,
                    dnis: this.number ? this.number : '',
                    group: group,
                }).then(res => {
                    if (res.count > 0) {
                        this.is_found = true;
                        console.log("res", res)
                        this.list = res.data;
                    } else {
                        this.list = []
                        this.is_found = false
                    }
                }).catch(e => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                })
            },
            getCountries() {
                this.$store.dispatch("getCountryList", {}).then(async (res) => {
                    this.countries = res.items;
                });
            },
            sorting(type, sortBy) {
                let order_dir = "";
                if (type === "up") {
                    order_dir = "desc";
                } else {
                    order_dir = "asc";
                }

                // this.order_dir = order_dir;
                // this.order_by = sortBy;

                this.getList(order_dir, sortBy);
            },
            downloadCSV() {
                let key = Object.keys(this.list[0])
                const csvContent = 'data:text/csv;charset=utf-8,' + key + '\n' +
                    this.list.map(e => {
                        return Object.values(e);
                    }).join('\n')

                var link = document.createElement('a')
                link.href = csvContent
                link.download = 'NumberReport.csv'
                link.click()
            },
            getStartTime(t) {
                const time = new Date(t).getTime();
                this.start_time = time / 1000;

                console.log("start/***", this.start_time)
            },
            getEndTime(t) {
                const time = new Date(t).getTime();
                this.end_time = time / 1000;
            },
            oneToTwoDigit(num) {
                return num.length === 1 ? `0${num}` : num;
            },
            dateFormat(date) {
                if (date == null) {
                    return "";
                }
                const converted_date = new Date(date);
                const year = converted_date.getFullYear().toString();
                const _month = (converted_date.getMonth() + 1).toString();
                const month = this.oneToTwoDigit(_month);
                const _day = converted_date.getDate().toString();
                const day = this.oneToTwoDigit(_day);
                const _hours = converted_date.getHours().toString();
                const hours = this.oneToTwoDigit(_hours);
                const _minutes = converted_date.getMinutes().toString();
                const minutes = this.oneToTwoDigit(_minutes);
                const _seconds = converted_date.getSeconds().toString();
                const seconds = this.oneToTwoDigit(_seconds);

                return `${year}:${month}:${day} ${hours}:${minutes}:${seconds}`;
            },
            getCurrentDateAndTime() {
                const date = new Date();
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();

                return {day, month, year};
            },
            setDateAndTime() {
                this.start_time = this.startTime / 1000;
                this.end_time = this.endTime / 1000;
            },
            selectDateAndTime(e) {
                this.start_time = new Date(e[0]).getTime() / 1000;
                this.end_time = new Date(e[1]).getTime() / 1000;
            },
            reasetFilters() {
                // if(!this.SearchText) {return}
                // this.SearchText = '';
                // this.getBulkReports();
                this.$router.go(0)
            },
            changePage(page) {
                this.Page = page;
                this.getList();
            },
            search() {
                this.getList();
            },
        }
    };
</script>

<style lang="scss" scoped>
    .checkbox-xl .custom-control-label::before,
    .checkbox-xl .custom-control-label::after {
        top: 1.2rem;
        width: 1.85rem;
        height: 1.85rem;
    }

    .checkbox-xl .custom-control-label {
        padding-top: 23px;
        padding-left: 15px;
        font-size: 16px;
        margin-right: 45px;
    }

    .search-div .search-input {
        width: 100%;

    }

    .groopBy_checkbox {
        display: flex;
        flex-wrap: wrap;
        padding: 20px;
    }

    .dashboard-container {
        //padding: 20px;

        .input-div {
            display: flex;
            align-items: center;
        }

        .right-wrapprr {
            display: flex;
            align-items: center;
        }

        .right-wrapprr > div {
            width: 25%;
        }

        .selects-wrapper {
            display: flex;
            align-items: center;
            background-color: #fff;
            width: 100%;
        }

        .selects-wraper {
            width: 357px;
        }

        .Bucketization {
            width: 100%;
        }

        .filter_by {
            height: 40px;
            color: #55616e;
            font-weight: 400;
            font-family: Helvetica Neue;
            font-size: 16px;
            line-height: 25px;
            padding: 10px 5px 10px 30px;
            white-space: nowrap;
            @media (max-width: 768px) {
                min-width: 120px;
            }

            &:first-child {
                padding-left: 0;
            }
        }
    }

    table.Invoice_table {
        width: 100%;
        margin-top: 21px;

        th {
            text-align: center;
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    }

    table thead th:first-child {
        padding-left: 20px;
        padding-right: 30px;
        width: 14%;
        background: #52a8ef;
        vertical-align: inherit;
    }

    table thead th.balance {
        padding-left: 20px;
        padding-right: 30px;
        width: 14%;
        background: #52a8ef;
        vertical-align: inherit;
    }

    table,
    tr {
        width: 100%;
        height: 44px;
        box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        background-color: #ffffff;
    }

    table tr th {
        padding: 7px 10px 7px 0;
    }

    table {
        border-collapse: collapse;
    }

    .Invoice_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;
    }

    tbody th {
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        height: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        padding: 7px 10px 7px 20px;
        text-align: left;
    }

    tbody th:first-child {
        padding: 5px 10px 5px 0;

        span {
            padding: 7px 0;
        }
    }

    .left-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .left-wrapper > div {
        /*background: #fff;*/
        /*width: 49%;*/
        /*padding: 10px 20px 10px 20px;*/
    }

    .search-div {
        .selects-wrapper {
            width: 100%;
        }

        span {
            font-weight: bold;
            font-size: 14px;
        }
    }

    .reset-button {
        width: 90px;
        height: 40px;
        margin: 10px 0 0 10px;
    }

    .PrimaryButton {
        cursor: pointer;
        height: 40px;
        width: 100%;
        border-radius: 4px;
        background-color: #51a3f3;
        color: #fff;
        outline: none;
        border: none;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        padding: 5px 20px 5px 20px;
    }

    .secondary-button {
        cursor: pointer;
        height: 100%;
        width: 100%;
        border: 1px solid #bdbfd8;
        border-radius: 4px;
        background-color: #fff;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        text-align: center;
        padding: 10px 20px 10px 20px;
    }

    .frequentlyused-div {
        margin-top: 10px;

        span {
            color: #55616e;
            font-weight: 400;
            font-family: "Helvetica Neue";
            font-size: 15px;
        }

        svg {
            fill: #55616e;
        }
    }

    .frequently-div {
        display: flex;
        margin-top: 5px;
        flex-wrap: wrap;
    }

    .frequently-div > div {
        background: #f8f9fe;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 30%;
        height: 40px;
        padding: 0 10px;
        border-radius: 3px;
        margin-right: 20px;

        span {
            font-weight: 600;
            color: black;
        }
    }

    .selectedus-div {
        margin-top: 10px;

        span {
            color: #55616e;
            font-weight: 400;
            font-family: "Helvetica Neue";
            font-size: 15px;
            opacity: 0.5;
        }

        svg {
            fill: #fff;
        }
    }

    .selected-div {
        display: flex;
        margin-top: 5px;
        flex-wrap: wrap;
    }

    .selected-div > div {
        background: #54aaec;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 30%;
        height: 40px;
        padding: 0 10px;
        border-radius: 3px;
        margin-right: 20px;

        span {
            font-weight: 600;
            color: #fff;
            opacity: 1;
        }
    }

    @media (max-width: 1400px) {
        .selected-div > div {
            width: 180px;
            margin-top: 5px;
        }
        .frequently-div > div {
            width: 180px;
            margin-top: 5px;
        }
    }

    @media (max-width: 1300px) {
        table.Invoice_table {
            width: 1385px;
        }
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }
</style>

